<section>
  <form [formGroup]="filterForm" class="container-filter">
    <mat-form-field>
      <mat-label>Busqueda</mat-label>
      <input formControlName="search" matInput (keyup.enter)="onSearch()">
    </mat-form-field>

    <mat-form-field>
      <mat-label>Aprobadores</mat-label>
      <mat-select formControlName="aprove" (selectionChange)="sendFilterAprove()">
        <mat-option *ngFor="let aprovator of approvators"
          [value]="aprovator.id">
          {{ aprovator.name }}
        </mat-option>    
      </mat-select>  
    </mat-form-field>

    <mat-form-field *ngIf="isMobile$ | async">
      <mat-label>Estados</mat-label>
      <mat-select formControlName="estado" (selectionChange)="onSelectSelectionChange($event)" multiple>
        <ng-container *ngFor="let group of groupedStates | keyvalue">
          <mat-option *ngFor="let state of group.value" [value]="state.id">
            {{ state.name }}
          </mat-option>
        </ng-container>
      </mat-select>
    </mat-form-field>   
  </form>

  <div class="centered-chip-list" *ngIf="!(isMobile$ | async)">
    <mat-chip-listbox class="mat-mdc-chip-set-stacked" aria-label="states" multiple>
      <div *ngFor="let group of groupedStates | keyvalue" style="margin-right: 38px;" class="chip-group-wrapper">
        <div class="chip-group">
          <mat-chip-option 
            *ngFor="let state of group.value" 
            (selectionChange)="onChipSelectionChange($event)" 
            appSimulationStyle
            [status]="state.id"
            [typeStyle]="'A'"
            [isSelected]="selectedIds.has(state.id)"
            [value]="state.id" 
            [selected]="selectedIds.has(state.id) || defaultSelectedIds.has(state.id)">
            {{ state.name }}
          </mat-chip-option>
        </div>
      </div>
    </mat-chip-listbox>
  </div>      
</section>